import { Button, Modal, ModalDialog, Stack, Typography } from "@mui/joy";
import useNSFWStore from "../stores/nsfwStore";

interface AgeVerificationModalProps {
  open: boolean;
  onClose: () => void;
}

export function AgeVerificationModal({
  open,
  onClose,
}: AgeVerificationModalProps) {
  const setAgeVerified = useNSFWStore((state) => state.setAgeVerified);
  const setNSFWEnabled = useNSFWStore((state) => state.setNSFWEnabled);

  const handleConfirm = () => {
    setAgeVerified(true);
    setNSFWEnabled(true);
    onClose();
    window.location.reload();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog
        sx={{
          maxWidth: 400,
          p: 3,
          borderRadius: "lg",
        }}
      >
        <Typography level="h4" sx={{ mb: 2 }}>
          Age Verification
        </Typography>
        <Typography level="body-md" sx={{ mb: 3 }}>
          NSFW mode is intended for users who are 18 years of age or older. Only
          characters that are marked as allowing NSFW content will be displayed.
        </Typography>
        <Stack direction="row" spacing={1} justifyContent="flex-end">
          <Button variant="plain" color="neutral" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={handleConfirm}>I am 18 or older</Button>
        </Stack>
      </ModalDialog>
    </Modal>
  );
}
